import { render, staticRenderFns } from "./JobDetailPreview.vue?vue&type=template&id=010976a8&scoped=true"
import script from "./JobDetailPreview.vue?vue&type=script&lang=js"
export * from "./JobDetailPreview.vue?vue&type=script&lang=js"
import style0 from "./JobDetailPreview.vue?vue&type=style&index=0&id=010976a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010976a8",
  null
  
)

export default component.exports